// values from this file are used in case there is no event in editor_module, that can be used

const SUBSCRIPTION_PREFIX = 'subscription';
export const SUBSCRIPTION_OVERVIEW = `${SUBSCRIPTION_PREFIX}:overview`;
export const YOUR_SUBSCRIPTION_CLICK = `${SUBSCRIPTION_PREFIX}:yourSubscriptionClick`;
export const SUBSCRIPTION_CHANGE_DURATION = `${SUBSCRIPTION_PREFIX}:changeDuration`;
export const SUBSCRIPTION_GET_PLAN = `${SUBSCRIPTION_PREFIX}:getPlan`;
export const SUBSCRIPTION_SEE_SUCCESS = `${SUBSCRIPTION_PREFIX}:seeSuccess`;
export const SUBSCRIPTION_CLICK_PLAN = `${SUBSCRIPTION_PREFIX}:clickPlan`;
export const SUBSCRIPTION_SHOW_COMPARISON_TABLE = `${SUBSCRIPTION_PREFIX}:showComparisonTable`;

// TODO: use it from the editor_module
const AUTHENTICATION_PREFIX = 'authentication';
export const AUTHENTICATION_SWITCH = `${AUTHENTICATION_PREFIX}:switchView`;
export const AUTHENTICATION_SHOW = `${AUTHENTICATION_PREFIX}:show`;
export const AUTHENTICATION_FORGOT_PASSWORD = `${AUTHENTICATION_PREFIX}:passwordForgot`;

export const POST_SHARE = `post:share`;
export const BLOG_SHARE = `blog:share`;

const CHALLENGE_PREFIX = 'challenge';
export const CHALLENGE_SHARE = `${CHALLENGE_PREFIX}:share`;
export const CHALLENGE_CLICK_PARTICIPATE = `${CHALLENGE_PREFIX}:clickParticipate`;
export const CHALLENGE_SUBMITTED = `${CHALLENGE_PREFIX}:submitted`;

const HEADER_PREFIX = 'header';
export const CLICK_UPGRADE_PLAN = `${HEADER_PREFIX}:clickUpgradePlan`;
export const NEW_PROJECT_BUTTON_CLICK = `${HEADER_PREFIX}:newProjectButton:click`;

export const TRENDING_CARD_CLICK = `trendingCard:click`;

export const NAVIGATION_AI_TOOLS = 'navigation:aiTools';

// Vectorizer events
const VECTORIZER_PREFIX = 'vectorizerSAP';
export const VECTORIZER_BACKGROUND_REMOVE = `${VECTORIZER_PREFIX}:backgroundRemove`;
export const VECTORIZER_VECTORIZE = `${VECTORIZER_PREFIX}:vectorize`;

// Image Section - Banner Button
export const IMAGE_SECTION_SLICE_BANNER_BUTTON_CLICK = `imageSection:bannerButtonClick`;

// Category
export const CATEGORY_PREFIX = 'category';
export const CATEGORY_KITTLAI_CLICK = `${CATEGORY_PREFIX}:KittlAI:click`;
export const CATEGORY_UPLOAD_CLICK = `${CATEGORY_PREFIX}:Upload:click`;

// UseCase
export const USECASES_PREFIX = 'useCases';
export const USECASES_CATEGORY = `${USECASES_PREFIX}:category:click`;
export const USECASES_SUB_CATEGORY = `${USECASES_PREFIX}:subcategory:click`;
export const USECASES_USECASE = `${USECASES_PREFIX}:useCase:click`;
export const USECASES_SUB_USECASE = `${USECASES_PREFIX}:subUseCase:click`;

// Filters
export const FILTERS_PREFIX = 'filters';

// Search
export const SEARCH_PREFIX = 'search';
export const SEARCH_TEMPLATES_WEBSITE = `${SEARCH_PREFIX}:templates:website`;

// Onboarding events
const ONBOARDING_PREFIX = 'onboarding';
export const ONBOARDING_USECASE_SELECTED = `${ONBOARDING_PREFIX}:useCaseSelected`;

// Landing pages events
const LANDING_PAGES_PREFIX = 'landingPages';
export const LANDING_PAGES_SIGN_UP_SHOW = `${LANDING_PAGES_PREFIX}:signupShow`;
export const LANDING_PAGES_TOGGLE_CLICK = `${LANDING_PAGES_PREFIX}:toggleClick`;
export const LANDING_PAGES_NAVIGATION_CLICK = `${LANDING_PAGES_PREFIX}:navigationClick`;

const HOME_PAGE_PREFIX = 'homePage';
export const HOME_PAGE_SING_UP_SHOW = `${HOME_PAGE_PREFIX}:signupShow`;
export const HOME_PAGE_TOGGLE_CLICK = `${HOME_PAGE_PREFIX}:toggleClick`;
export const TEMPLATE_BOOKMARK = `template:bookmark`;
export const TEMPLATE_COMMENT = `templateView:addComment`;

const COLLAB = 'collab';
export const COLLAB_COPY_LINK = `${COLLAB}:share:copyLink`;
